import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";
import Glide, {Controls, Swipe, Breakpoints, Autoplay} from "@glidejs/glide/dist/glide.modular.esm";

export default class CarouselBehaviour extends AbstractDataAttributeBehaviour {
    attrNames = {
        container: 'data-carousel',
        containerConfig: 'data-carousel-config',
        navigation: 'data-carousel-nav',
        navigationConfig: 'data-carousel-nav-config',
        navigationLink: 'data-carousel-nav-go',
    };

    defaultConfig = {
        autoplay: false,
        perView: 1,
        bound: true,
        breakpoints: {
            480: { perView: 1},
            600: { perView: 2},
            1025: { perView: 3}
        }
    };

    defaultNavConfig = {
        perView: 5,
        breakpoints: {
            1025: {
                perView: 5
            },
            640: {
                perView: 3
            },
        }
    };

    getContainerSelector = () => {
        return '[' + this.attrNames.container + ']';
    };

    getConfig = () => {
        return document.querySelector(this.getContainerSelector()).getAttribute(this.attrNames.container);
    };

    getNav = (name) => {
        return document.querySelector(this.getNavSelector(name));
    }

    getNavSelector = name => {
        return '[' + this.attrNames.navigation + '="'+ name +'"]';
    };

    getNavConfig = () => {
        return document.querySelector(this.getContainerSelector()).getAttribute(this.attrNames.container);
    }

    getName = container => container.getAttribute( this.attrNames.container );

    initContainer = (container) =>  {
        if(!window.glide) window.glide = {};
        let name = this.getName(container);
        let nav = this.getNav(name);

        this.initSlider(container, name);
        if(nav) this.initNav(nav, name);
    };


    initSlider = (container, name) => {
        let config = JSON.parse(container.getAttribute(this.attrNames.containerConfig));
        if(!config) config = this.defaultConfig;

        window.glide[name] = new Glide(container, config ).mount({Autoplay, Controls, Breakpoints, Swipe});
        window.glide[name].on('run.after', () => { window.lazy.update() });
    };


    init = () => {
        this.getContainers().forEach((container) => {
            if (this.isContainerInitialised(container)) return;
            this.setContainerInitialised(container);
            this.initContainer(container);
        });

        if (window.dataAttrBehaviours.TabsBehaviour) {
            window.dataAttrBehaviours.TabsBehaviour.registerOnChangeCallback('carousel-changed', () =>{
                this.refresh();
            })
        }

        if (window.dataAttrBehaviours.HideShowBehaviour) {
            window.dataAttrBehaviours.HideShowBehaviour.registerOnChangeCallback('hideshow-changes', () =>{
                this.refresh();
            })
        }
    }

    initNav = (nav, name) => {
        let config = nav.getAttribute(this.attrNames.navigationConfig);
        if(!config) config = this.defaultNavConfig;

        window.glide[name + '--nav'] = new Glide(nav, config).mount({Controls, Breakpoints });
        window.glide[name + '--nav'].on('run.after', () => { window.lazy.update() });

        nav.querySelectorAll('.glide__slide').forEach(slide=>{
            slide.addEventListener('click', (e) => {
                window.glide[name].go('=' + e.currentTarget.getAttribute(this.attrNames.navigationLink));
            })
        });
        window.glide[name].on('run', () => {
            nav.querySelectorAll('.glide__slide').forEach(slide=> {
                if (slide.getAttribute(this.attrNames.navigationLink) == window.glide[name].index) {
                    slide.classList.add('active');
                } else {
                    slide.classList.remove('active');
                }
            });
        });
    };

    refresh = (timeout = 10) => {
        setTimeout(() => {
            this.getContainers().forEach(this.initContainer);
            window.lazy.update();
        }, timeout);
    }
}
